import React, { Component } from 'react';
import CheckoutSummary from './CheckoutSummary';
import {Elements} from 'react-stripe-elements';
import PLForm from './PL-form';




class CheckoutForm extends Component {
  render() {
    return (
      <main role="main" id="container" className="main-container push">
        <section className="checkout">
          <div className="content">
            <CheckoutSummary />
            <Elements>
              <PLForm/>
            </Elements>
          </div>
        </section>
      </main>
    );
  }
}



export default CheckoutForm ;





// WEBPACK FOOTER //
// ./src/components/Checkout/CheckoutForm.js